import useBulkPerformerData from '../hooks/useBulkPerformerData'

interface Props {
  codes: string[]
}

const PerformerDataFetcher: React.FC<Props> = (props: Props) => {
  const { codes } = props

  useBulkPerformerData({ codes })

  return null
}

export default PerformerDataFetcher
